module.exports = __webpack_public_path__ + "img/welcome.571abe8b.png";